<template>
  <div class="products">
    <RouterView />
  </div>
</template>
<script>
export default {
  name: 'ProductIndex',
  created () {
    this.$root.trackEvent({
      eventCategory: 'MobileAppListing',
      eventAction: 'ürünsayfasıclick',
      eventLabel: 'ürünsayfasıclick',
    });
  },
};
</script>
